export const populateNotifications = <T extends string>(
  actionName: T
): [`NOTIFY_${T}_PENDING`, `NOTIFY_${T}_SUCCESS`, `NOTIFY_${T}_ERROR`] => [
  `NOTIFY_${actionName}_PENDING`,
  `NOTIFY_${actionName}_SUCCESS`,
  `NOTIFY_${actionName}_ERROR`,
];

export const populateActions = <T extends string>(
  actionName: T
): [`${T}_REQUEST`, `${T}_SUCCESS`, `${T}_ERROR`] => [
  `${actionName}_REQUEST`,
  `${actionName}_SUCCESS`,
  `${actionName}_ERROR`,
];
